<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Bonus Listesi</h1>
          </div>

          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item">
                <a>Anasayfa</a>
              </router-link>
              <li class="breadcrumb-item active">Bonus Listesi</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>

    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Bonus Listesi
                <router-link
                  tag="button"
                  to="/bonus-list/settings/info/0"
                  class="btn btn-primary btn-sm float-right"
                  title="Bonus Ekle"
                >
                  <i class="fas fa-plus"></i>
                  Bonus Ekle
                </router-link>
              </div>
              <div class="card-body">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <div class="row p-3 justify-content-start">
                    <div class="col-md-4">
                      <input
                        type="text"
                        placeholder="Bonus Adı"
                        class="form-control form-control-sm"
                        v-model="search.bonusName"
                      />
                    </div>
                    <div class="col-md-2">
                      <select
                        class="form-control form-control-sm"
                        v-model="search.gelen_aktif_filtre"
                      >
                        <option disabled selected>Durum Seçiniz</option>
                        <option value="0">Hepsi</option>
                        <option value="1">Aktif</option>
                        <option value="2">Pasif</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <button class="btn btn-info btn-sm" @click="searchFilter">
                        <i class="fas fa-search"></i> Filtrele
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        @click="reset"
                        title="Filtreleri Temizle"
                      >
                        <i class="fas fa-times-circle"></i>
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped projects">
                      <thead>
                        <tr>
                          <th style="width: 1%">#</th>
                          <th style="width: 7%">Sıra No</th>
                          <th>Bonus Adı</th>
                          <th>Başlangıç/Bitiş Tarihi</th>
                          <th
                            style="width: 8%"
                            class="text-center"
                            v-if="
                              auth.UserSetting != null &&
                              auth.UserSetting.isWrite
                            "
                          >
                            Aktif/Pasif
                          </th>
                          <th
                            style="min-width: 250px"
                            v-if="
                              auth.UserSetting != null &&
                              auth.UserSetting.isWrite
                            "
                          ></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(bonus, index) in bonusList" :key="bonus.id">
                          <td>{{ ++index + (page - 1) * count }}</td>
                          <td>
                            <div class="input-group input-group-sm">
                              <input
                                type="number"
                                v-model="bonus.SortNumber"
                                class="form-control"
                              />
                              <span class="input-group-append">
                                <button
                                  type="button"
                                  class="btn btn-info btn-flat"
                                  @click="saveSortNumber(bonus)"
                                >
                                  <i class="fas fa-save"></i>
                                </button>
                              </span>
                            </div>
                          </td>
                          <td>{{ bonus.name }}</td>
                          <td>
                            {{ bonus.baslangicTarih | DateFormat }} -
                            {{ bonus.bitisTarih | DateFormat }}
                          </td>
                          <td
                            class="project-state"
                            v-if="
                              auth.UserSetting != null &&
                              auth.UserSetting.isWrite
                            "
                          >
                            <button
                              class="btn btn-sm btn-block btn-outline-primary"
                              :class="{
                                'btn-outline-success': bonus.isAktif,
                                'btn-outline-danger': !bonus.isAktif,
                              }"
                              @click="changeIsAktif(bonus)"
                            >
                              {{ bonus.isAktif ? "Aktif" : "Pasif" }}
                            </button>
                          </td>
                          <td
                            class="project-actions text-right"
                            v-if="
                              auth.UserSetting != null &&
                              auth.UserSetting.isWrite
                            "
                          >
                            <router-link
                              tag="button"
                              :to="'/bonus-list/settings/info/' + bonus.ID"
                              class="btn btn-sm btn-warning btn-sm"
                              title="Bonus Düzenle"
                            >
                              <i class="fas fa-pencil-alt"></i>
                            </router-link>
                            <button
                              class="btn btn-sm btn-danger btn-sm"
                              @click="deleteItem(bonus.ID)"
                              title="Bonus Sil"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td
                            v-if="bonusList.length == 0"
                            colspan="6"
                            class="text-center"
                          >
                            Kayıt bulunamadı
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <pagination
                  v-model="page"
                  :records="rows"
                  :per-page="count"
                  @paginate="pagination"
                />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
export default {
  data() {
    return {
      auth: this.$store.getters.getModules,
      page: 1,
      count: 10,
      rows: 0,
      bonusList: [],
      overlay: false,
      search: {
        bonusName: "",
        gelen_aktif_filtre: 0,
      },
    };
  },
  methods: {
    getBonusList(type = false) {
      //**bonus listesini getir;backend pagination için rowsları alabilmek için 2 istek atmak gerekti. */
      if (!type) this.overlay = true;
      this.$http
        .post("Bonus/ListBonus", {
          name: this.search.bonusName,
          gelen_aktif_filtre: this.search.gelen_aktif_filtre,
          rowNumber: type,
          page: this.page - 1,
        })
        .then((response) => {
          if (type) this.rows = response.data;
          else {
            this.bonusList = response.data;
            this.overlay = false;
          }
        });
    },
    saveSortNumber(bonus) {
      //**sıra numarası */
      this.overlay = true;
      this.$http
        .get(`Bonus/ChangeBonusOrder/${bonus.ID}?order=${bonus.SortNumber}`)
        .then((response) => {
          toastr.success(`'${bonus.name}' bonusu sıra no güncellendi.`);
          this.overlay = false;
        });
    },
    changeIsAktif(bonus) {
      //**aktif pasif değiştirme */
      this.overlay = true;
      this.$http
        .get(`Bonus/ChangeBonusStatus/${bonus.ID}`)
        .then((response) => {
          toastr.success(`'${bonus.name}' bonusu durum güncellendi`);
          this.getBonusList();
          this.overlay = false;
        });
    },
    pagination() {
      //**pagination eventlarına göre bonus list apisini çağır  */
      this.getBonusList();
      this.getBonusList(true);
    },
    searchFilter(){
      this.page=1;
       this.getBonusList();
      this.getBonusList(true);
    },
    reset() {
      this.page = 1;
      this.search = {
        bonusName: "",
        gelen_aktif_filtre: 0,
      };
      this.getBonusList();
      this.getBonusList(true);
    },
    deleteItem(_bonusId) {
      Swal.fire({
        title: "Kayıt kalıcı olarak silinecek!Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Silinsin",
        cancelButtonText: "İptal",
        icon: "question",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.get(`Bonus/DeleteBonus/${_bonusId}`).then(
            (response) => {
              toastr.success("Bonus silindi.");
              this.getBonusList();
            },
            (err) => {
              toastr.error(err.data.Message);
            }
          );
        }
      });
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.getBonusList();
    this.getBonusList(true);
  },
  watch: {
    "$store.getters.getSite"() {
      this.getBonusList();
      this.getBonusList(true);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/BonusList/BonusList.vue